<template>
  <v-tooltip top open-delay="700">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        small
        v-bind="attrs"
        v-on="on"
        :disabled="item.no_carrinho"
        @click="consolidar"
      >
        <v-icon>mdi-format-vertical-align-center</v-icon>
      </v-btn>
    </template>

    <span>
      Consolidar todas as <strong>Sugestões ({{qtdPorConsolidar}})</strong>
      de Compra para a <strong>Filial</strong> {{item.filial}}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ConsolidaSugestoesBotao",
  props: {
    item: Object,
    qtdPorConsolidar: Number
  },
  data: () => ({
    dialogAtivo: false
  }),
  methods: {
    consolidar() {
      this.$emit("consolidar", this.qtdPorConsolidar)
    }
  }
}
</script>

<style scoped>

</style>
